module.exports = __webpack_public_path__ + "static/media/missing-sensors.6d50532d.gif";